// extracted by mini-css-extract-plugin
module.exports = {"funcionamento":"Funcionamento_funcionamento__2nRAf","fechado":"Funcionamento_fechado__mS927"};